import React, { Fragment, useEffect, useState } from 'react'
import GamesService from 'services/GamesService'
import UserService from 'services/UserService'
import Home from '@/pages/Home'
import GamesList from 'features/GamesList/GamesList'
import getTexts from 'utils/localization'
import Wrapper from 'ui/Wrapper'
import styled from 'styled-components'
import device from 'utils/mediaQueries'
import Button from 'ui/controls/Button'
import Box from 'ui/Box'
import { detectMobile } from 'common/adapters/DeviceDetectAdapter'

const FlexWrapper = styled(Wrapper)`
    display: flex;
    overflow: auto;
    flex-direction: row;
    flex-wrap: wrap;
    max-width: 1500px;
    width: 100%;
    margin: 0 auto;
    @media screen and ${device.xxl} {
        max-width: 1000px;
    }
    @media screen and ${device.xl} {
        max-width: 900px;
    }
`

const t = getTexts()

const GAMES_COUNT_TO_SHOW = 8

const ForYouPage = ({ userProfile }) => {
    const [favoriteGames, setFavoriteGames] = useState([])
    const [recommendedGames, setRecommendedGames] = useState([])
    const [popularGames, setPopularGames] = useState([])
    const [recentGames, setRecentGames] = useState([])
    const [isUserLoggedIn, setIsUserLoggedIn] = useState(false)
    const [gamesToShow, setGamesToShow] = useState(GAMES_COUNT_TO_SHOW)
    const userId = userProfile.id

    const loadMore = (increment = GAMES_COUNT_TO_SHOW) => {
        setGamesToShow(gamesToShow + increment)
    }

    const getPopularGames = () => {
        GamesService.fetchPopularGames({
            limit: GAMES_COUNT_TO_SHOW,
            period: 1,
            excludeHot: true,
        })
            .then((games) => {
                setPopularGames(games)
            })
            .catch((e) =>
                console.error('Popular games request failed with message: ', e)
            )
    }

    useEffect(() => {
        const subscription = UserService.getUserLoggedStatus().subscribe(
            (loggedInStatus) => {
                setIsUserLoggedIn(loggedInStatus)

                if (!loggedInStatus) {
                    UserService.openLoginModal()
                }
            }
        )

        return () => {
            subscription.unsubscribe()
        }
    }, [])

    useEffect(
        () => {
            if (userId) {
                GamesService.fetchRecommendedGames()
                GamesService.setRecentlyPlayedGames(userId).then((e) => {})

                const favoriteSubscription = GamesService.getFavoriteGames().subscribe(
                    (res) => {
                        if (res) {
                            setFavoriteGames(res)
                        }
                    }
                )

                const recentGamesSubscription = GamesService.getRecentlyPlayedGames().subscribe(
                    (res) => {
                        if (res) {
                            setRecentGames(res)
                        }
                    }
                )

                const recommendedGamesSubscription = GamesService.getRecommendedGames().subscribe(
                    (res) => {
                        if (res.length > 0) {
                            setRecommendedGames(res)
                        } else {
                            getPopularGames()
                        }
                    }
                )

                return () => {
                    favoriteSubscription.unsubscribe()
                    recommendedGamesSubscription.unsubscribe()
                    recentGamesSubscription.unsubscribe()
                }
            }
        },
        [userId]
    )

    return isUserLoggedIn ? (
        <Wrapper padding="0 0 10px">
            <FlexWrapper>
                {favoriteGames.length > 0 && (
                    <Fragment>
                        <GamesList
                            gamesToShow={gamesToShow}
                            heading={t.forYou.favoriteTitle}
                            games={favoriteGames}
                            withMoreSection={false}
                            cardSize={detectMobile() ? 'x4' : 'x2'}
                        />
                        {favoriteGames.length > gamesToShow && (
                            <Box style={{ textAlign: 'center' }}>
                                <Button
                                    black
                                    size={'x1'}
                                    onClick={() => loadMore()}
                                >
                                    {t.forYou.loadMore}
                                </Button>
                            </Box>
                        )}
                    </Fragment>
                )}
            </FlexWrapper>
            {recommendedGames.length > 0 ? (
                <FlexWrapper>
                    <GamesList
                        gamesToShow={GAMES_COUNT_TO_SHOW}
                        heading={t.forYou.recommendGamesTitle}
                        games={recommendedGames}
                        withMoreSection={false}
                        cardSize={'x2'}
                    />
                </FlexWrapper>
            ) : (
                popularGames.length > 0 && (
                    <FlexWrapper>
                        <GamesList
                            gamesToShow={GAMES_COUNT_TO_SHOW}
                            heading={t.forYou.popularTitle}
                            games={popularGames}
                            withMoreSection={false}
                            cardSize={'x2'}
                        />
                    </FlexWrapper>
                )
            )}
            {recentGames.length > 0 && (
                <FlexWrapper>
                    <GamesList
                        gamesToShow={GAMES_COUNT_TO_SHOW}
                        heading={t.forYou.recentlyPlayedTitle}
                        games={recentGames}
                        withMoreSection={false}
                        cardSize={'x2'}
                    />
                </FlexWrapper>
            )}
        </Wrapper>
    ) : (
        <Home />
    )
}

export default ForYouPage
